export enum ModuleType {
  INTRO = 'intro',
  SPEAKING = 'speaking',
  ATIS = 'atis',
  LISTENING = 'listening',
  DESCRIBING = 'describing',
  OUTRO = 'outro',
}
